__turbopack_context__.v({
  "moreButton": "MoreButton-module-scss-module__EmElwG__moreButton",
});
